import { render } from "./createCraIssue.vue?vue&type=template&id=b230dcf6&scoped=true"
import script from "./createCraIssue.js?vue&type=script&lang=js"
export * from "./createCraIssue.js?vue&type=script&lang=js"

import "./createCraIssue.vue?vue&type=style&index=0&id=b230dcf6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b230dcf6"]])

export default __exports__